module.exports = __webpack_public_path__ + "static/media/layer_4.402cba0f.svg";